import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { ChangePasswordComponent } from './change-password.component';
import { StoreModule} from '@ngrx/store';
import { FEATURE_NAME } from './state-management/change-password.state';
import { changePasswordReducer } from './state-management/change-password.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ChangePasswordEffects } from './state-management/change-password.effects';


@NgModule({
  imports: [
    StoreModule.forFeature(FEATURE_NAME, changePasswordReducer),
    EffectsModule.forFeature([ChangePasswordEffects]),

    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,

    TranslateModule,
    FuseSharedModule,
  ],
  declarations: [ChangePasswordComponent],
  exports: [],
})
export class ChangePasswordModule {}
